import React from 'react';
import * as Icon from "react-bootstrap-icons";
import { useState, Fragment, useEffect, useRef } from "react";
import Cookies from 'js-cookie';
import "../chatAiComponents/ChatAi.css";
import Broom from "../../assets/cleaning-icon.svg";
import calender from "../../assets/calendar_month.svg";
import loader_gif from "../../assets/loader.gif"
import { sendPromptText, promptListing, promptPaginationListing, paginationCounter, apiCallHiderStore, greetingMessage, cleanFullChat } from "../../redux/actions/chatAiActions";
import { useDispatch, useSelector } from 'react-redux';
import { db } from '../../firebase'; // Update the path to your firebaseConfig.js file
import { ref, onValue } from 'firebase/database';
import { Mixpanel } from '../../Mixpanel';
import { Transition,Combobox } from '@headlessui/react'
import { XMarkIcon ,CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import Multiselect from 'multiselect-react-dropdown';

const people = [
  { id: 1, name: 'Leslie Alexander' },
  { id: 2, name: 'Alexander' },
  { id: 3, name: 'Leslie' },
  { id: 4, name: 'liexander' },
  { id: 5, name: 'LesAlex' },
  { id: 6, name: 'Leander' },
  // More users...
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ChatbotViewer = (props)=> {
  const textareaRef = useRef(null);
  const messageEl = useRef(null);
  const [promptText, setPromptText] = useState("");
  const [suggestionDelay, setSuggestionDelay] = useState(false);
  const [generatingLoader, setGeneratingLoader] = useState(false);
  const [counterAnswerInput, setCounterAnswerInput] = useState("");
  const [chatDelayStatus, setChatDelayStatus] = useState(false);
  const [lastCounterData, setLastCounterData] = useState({});
  const [learnMoreIds, setLearnMoreIds] = useState([]);
  const [counterQuestionLoad, setCounterQuestionLoad] = useState(null);
  const [otherCounterQuestion, setOtherCounterQuestion] = useState("");
  const [selectKey, setSelectKey] = useState("");
  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(null)

  const filteredPeople = query === '' ? people : people.filter((person) => { return person.name.toLowerCase().includes(query.toLowerCase()) })
  const [message, setMessage] = useState({is_writing:false,answer:"",block_id: null,prompt: ""});
  const [firebaseLoader, setFirebaseLoader] = useState(false);
  const [chatData, setChatData] = useState([]);
  // const [chatCount, setChatCount] = useState(null);
  const [otherData, setOtherData] = useState(null);
  const client_id = useSelector((state) => state.assetLibrary?.userData?.client_id);
  
  const [lastPrompt, setLastPrompt] = useState({});
  const [newPrompt, setNewPrompt] = useState({});
  const [inputFieldDisable, setInputFieldDisable] = useState(false);
  const [hideGreetingSuggestion, setHideGreetingSuggestion] = useState(false);
  const [temp, setTemp] = useState(false);
  const [chatTransition, setChatTransition] = useState(true);
  const [showText, setShowText] = useState("");
  const [show, setShow] = useState(false);
  const [updateCounterStatus, setUpdateCounterStatus] = useState("Answer question in the chat below");
  const [inputActivity, setInputActivity] = useState(false);
  const [meetingName, setMeetingName] = useState("");
  const [meetingEmail, setMeetingEmail] = useState("");
  const [meetingReason, setMeetingReason] = useState("");
  const [meetingDate, setMeetingDate] = useState("");
  const [meetingTime, setMeetingTime] = useState("");
  const [selectedWidgetData, setSelectedWidgetData] = useState([]);
  const [moreIds, setMoreIds] = useState([]);
  const [counter, setCounter] = useState(0);
  const debugger_mode = useSelector((state) => state.assetLibrary?.debugger_mode);
  const paginationCount = useSelector((state) => state.chatAi.paginationCount);
  const greeting_message = useSelector((state) => state.chatAi.greeting_message);
  const total_page = Math.ceil(paginationCount/10);
  const dispatch = useDispatch();
  const authToken = props.authToken;
  let nchatId = Cookies.get('chatid');

  
  // const [backgroundColor,setBackgroundColor] = useState("#F0F0F0");
  // const [textColor,setTextColor] = useState("#000000");
  // const [themeColor,setThemeColor] = useState("var(--brand-primary)");
  // const [barColor,setBarColor] = useState("#ffffff");
  
  const prompt_list = useSelector((state) => state.chatAi.prompt_list);
  const isLoading = useSelector((state) => state.chatAi.chat_loading);
  
  const inputActivityHandler = (value) => {
    setInputActivity(value)
  }
  
  const sendPrompt = async (text, c_a, m_d, flag) => {
    let chatId = Cookies.get('chatid');
    let widgetDataPayload = [];
    await dispatch(sendPromptText(props.authToken, client_id, widgetDataPayload, onSuccessTransition, onSuccessList, onSuccess, onFailure, debugger_mode, chatId, text, c_a, m_d, flag));
    // setInputActivityHandler(true);
  }
  
  const truncateStringAfterSymbol = (inputString, symbol) => {
    const index = inputString?.indexOf(symbol);
    if (index !== -1) {
      setGeneratingLoader(true);
      return inputString.substring(0, index);
    } else {
      setGeneratingLoader(false);
    }
    return inputString;
  }
  
  const handleOptions = (key, value, type) => {
    const updatedSelectedWidgetData = [...selectedWidgetData];
    if ( updatedSelectedWidgetData[key] && updatedSelectedWidgetData[key].includes(value)) {
      updatedSelectedWidgetData[key] = updatedSelectedWidgetData[key].filter(
        (item) => item !== value
      );
    } else {
      if (type == "single") {
        updatedSelectedWidgetData[key] = [value];
      } else {
        updatedSelectedWidgetData[key] = [
          ...updatedSelectedWidgetData[key],
          value,
        ];
      }
    }

    setSelectedWidgetData(updatedSelectedWidgetData);
  };
  
  
  const onSuccess = () => {
    inputActivityHandler(false);
    setTimeout(() => {
      setFirebaseLoader(false);
    }, 1000);
  }
  
  const onFailure = () => {
    inputActivityHandler(false);
    setTimeout(() => {
      setFirebaseLoader(false);
    }, 1000);
  }
  
  // Socket variables
  useEffect(() => {
    let chatId = Cookies.get('chatid');
    const socket = new WebSocket(`wss://staging1.askzoi.com/socket_stream/${chatId}/`);

    // Connection opened
    socket.addEventListener('open', function (event) {
      console.log('WebSocket connected');
    });

    // Listen for messages
    socket.addEventListener('message', function (event) {
        // console.log('Message from server:', event.data);
        // Display incoming message in the chat box
        const data =JSON.parse(event.data);
        // setFMessage(data?.answer)
        // setIsWriting(data?.is_writing)
        // console.log(data?.answer,"answer")
        // console.log(data,"write")
        // appendMessage("Server Message =" + event.data);
        console.log(data,"data")
        setChatData(data);
        const truncatedString = truncateStringAfterSymbol(data[data.length - 1]?.answer, "$");

        let objAnswer = {
                  answer: truncatedString,
                  block_id: null,
                  is_writing: data[data.length - 1].is_writing,
                  prompt: data[data.length - 1].prompt
                }
                setMessage(objAnswer);
    });

    // Error handling
    socket.addEventListener('error', function (error) {
        console.error('WebSocket encountered error:', error);
    });

    // return () => {
    //     socket.close();
    // };
}, [nchatId]);

// Socket variables


  // useEffect(() => {
  //   let chatId = Cookies.get('chatid');
  //   const crawlingRef = ref(db, `/users/${client_id}/chat/${chatId}/conversation`);
  //   const onIdStatusChange = onValue(crawlingRef, (snapshot) => {
  //     const idStatus = snapshot.val();
  //     if (idStatus !== null && idStatus?.length !== chatData?.length) {
  //       setChatData(idStatus);
  //       const truncatedString = truncateStringAfterSymbol(idStatus[idStatus.length - 1].answer, "$");
  //       let objAnswer = {
  //         answer: truncatedString,
  //         block_id: idStatus[idStatus.length - 1].block_id,
  //         is_writing: idStatus[idStatus.length - 1].is_writing,
  //         prompt: idStatus[idStatus.length - 1].prompt
  //       }
  //       setMessage(objAnswer);
  //     }
  //   });

  //   return () => {
  //     // Cleanup by detaching the listener when component unmounts
  //     onIdStatusChange();
  //   };
  // }, [firebaseLoader]);
  
  const promptAdd = (e) => {
    setPromptText(e.target.value);
    setTemp(true);
  }  
  
  useEffect(() => {
    Mixpanel.track('Tested the chatbot');
    if (messageEl?.current) {
      messageEl.current.addEventListener('scroll', handleScroll);
    }
    
    return () => {
        messageEl.current.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const sentDirectMsg = (msg) => {
    setFirebaseLoader(true);
    // setChatCount(chatData.length);
    let obj = {
        id: null,
        prompt: msg,
        answer: "Loading",
        urls: null
    }
    setHideGreetingSuggestion(true);
    setPromptText("");
    setNewPrompt(obj);
    sendPrompt(msg, "", "");
    setTemp(true);
  }  
  
  const handleScroll = async () => {
    const { scrollTop } = messageEl.current;
    if (scrollTop === 0) {
      setCounter(prev => prev + 1);
    }
  };

  const handleTextareaResize = (event) => {
    // Set the height of the text area based on its scroll height
    const textarea = textareaRef.current;
      textarea.style.height = "auto"; // Reset the height to auto to recalculate the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set the height based on scrollHeight
    
  };

  const handleMore = (id) => {
    setMoreIds((prevIds) => [...prevIds, id]);
  };

  const handleLess = (id) => {
    setMoreIds((prevIds) => prevIds.filter((prevId) => prevId !== id));
  };
  
  const onSuccessClean = () => {
    generateRandomToken();
    setHideGreetingSuggestion(false);
    setInputFieldDisable(false);
    setUpdateCounterStatus("Answer question in the chat below");
  }
  
  const cleanChat = () => {
    if (firebaseLoader !== true) {
      let chatId = Cookies.get('chatid');
      dispatch(cleanFullChat(authToken, chatId, onSuccessClean, onSuccessTransition, onSuccessList));
      setChatData([]);
      // setChatCount(0);
    }     
  }
  
  const formatDate = (dateString) => {
    const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
    const date = new Date(dateString);
    const dateFormatted = date.toLocaleDateString('en-US', options); 
    return dateFormatted.replaceAll(",", "");
  };
  
  const formatTime = (meetingTime) => {
    var [h, m] = meetingTime.split(":");
    let hours
    if (h > 12) {
      hours = `${ (h-12) > 9 ? "":"0" }${ h-12 }`
    } else {
      hours = h;
    }
    return `${ hours }:${ m }:00 ${ h > 12 ? "PM":"AM" }`
  }
  
  useEffect(() => {
    if (textareaRef?.current && (inputFieldDisable !== true || isLoading !== true) ) {
      textareaRef.current.focus();
    }
  }, [inputFieldDisable, isLoading])
  
  const handleWidgetSubmit = async() => {
    console.log("selectedWidgetData",selectedWidgetData);
    console.log("lastCounterData", lastCounterData);
    let widgetDataPayload = [];
    let chatId = Cookies.get('chatid');
    await selectedWidgetData.map(async (item) => {
      return (
        await item.map((inner_item) => {
          return (
            widgetDataPayload.push(inner_item)
          )
        })
      )
    });
    setChatTransition(false);
    if (widgetDataPayload.length !== 0) {
      await dispatch(sendPromptText(props.authToken, client_id, widgetDataPayload, onSuccessTransition, onSuccessList, onSuccess, onFailure, debugger_mode, chatId, "", "", "", lastCounterData.chatbot_id, lastCounterData.widget_type));
    }
  }
  
  const sendPromptCommon = async (path) => {
    setFirebaseLoader(true);
    // setChatCount(chatData.length);
    let counter_array = prompt_list[prompt_list.length - 1];
    let meeting_data =  {
      name: meetingName,
      email: meetingEmail,
      description: meetingReason,
      date: formatDate(meetingDate),
      time: formatTime(meetingTime)
    }
    if (counter_array?.counter_question.length < 1) {
      setChatDelayStatus("xyz");
    }
    setPromptText("");    
    if (path === "main_input") {
      let obj = {
        id: null,
        prompt: promptText || counterAnswerInput,
        answer: "Loading",
        urls: null
      }
      setNewPrompt(obj);
      await sendPrompt(promptText, "", "");
    } else {
      setNewPrompt({});
      inputActivityHandler(false);
      await sendPrompt(counterAnswerInput, counter_array?.counter_question[counter_array.counter_question.length-1],meeting_data,counter_array?.id);
      setCounterAnswerInput("");
    }
  }
  
  const disableInputField = () => {
    let counter_array = prompt_list[prompt_list?.length - 1];
    if (counter_array?.counter_question.length === 0 || updateCounterStatus.includes("skipped") || counter_array?.counter_question[counter_array?.counter_question.length-1].acknowledgement !== "") {
      setInputFieldDisable(false);
    } else {
      setInputFieldDisable(true);
    }
  }
  
  const handleLearnMore = (id) => {
    setLearnMoreIds((prevIds) => [...prevIds, id]);
  };

  const handleLearnLess = (id) => {
    setLearnMoreIds((prevIds) => prevIds.filter((prevId) => prevId !== id));
  };
  
  useEffect(() => {
    if (counter < total_page && counter !== 0) {
      callPaginationApi();
    }
  }, [counter])
  
  const callPaginationApi = async () => {
    const { scrollHeight } = messageEl.current;
    await dispatch(promptPaginationListing(authToken, counter, prompt_list));
    messageEl.current.scroll({ top: scrollHeight-((counter-1)*2451)});
  }
  
  useEffect(() => {
    dispatch(paginationCounter(0));
    setHideGreetingSuggestion(false);
    dispatch(greetingMessage(authToken));
    dispatch(promptListing(authToken, onSuccessTransition, onSuccessList, "external"));
    setTimeout(() => {
      setShowText(true);
    }, 100);
  }, [])
  
  const onSuccessList = (path) => {
    if (path === "external" && props?.autoQuestion !== "") {
      setTimeout(() => {
          sentDirectMsg(props?.autoQuestion);
      }, 1000);
    }
  }
  
  const onSuccessTransition = () => {
    setChatTransition(true);
  }
  
  const generateRandomToken = () => {
    const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
    const expiryDate = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
    Cookies.set('chatid', `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
  };
  
  useEffect(() => {
    return () => {
      setTimeout(() => {
        dispatch(apiCallHiderStore(""));
      }, 1000);
    }
  }, [])
  
  useEffect(() => {
    let objAnswer = {
      answer: "",
      block_id: null,
      is_writing: false,
      prompt: ""
    }
    setGeneratingLoader(false);
    setMessage(objAnswer);
    if (temp === true) {
      inputActivityHandler(true);
    } else {
      inputActivityHandler(false);
    }
    if (prompt_list?.length > 0) {
      disableInputField();
      let lastData = prompt_list[prompt_list?.length-1];
      setLastPrompt(lastData);
      // if (lastData.counter_question.length !== 0) {
      //   setChatTransition(true);
      // } else {
      //   setChatTransition(false);
      // }
      setLastCounterData(lastData?.counter_question[lastData?.counter_question?.length-1])
      setHideGreetingSuggestion(false);
      if (lastPrompt?.suggestions?.length > 0 && temp === true) {
        setSuggestionDelay(true);
        setTimeout(() => {
          setSuggestionDelay(false);
        }, 1000);
      } else {
        setSuggestionDelay(false);
      }
      if (lastData?.counter_question?.length > 0 && lastData?.counter_question[lastData?.counter_question?.length-1].acknowledgement === "" && temp === true ) {
        if (lastData?.counter_question.length === 1) {
          setChatDelayStatus("xyz");
          setTimeout(() => {
            setChatDelayStatus(true);
            setTimeout(() => {
              setChatDelayStatus(false);
            }, 3000);
          }, 1000);
        }
      } else {
        setChatDelayStatus(false);
      }
    }
  }, [prompt_list]);
  
  const adjustHeight = () => {
    var dynamicDiv = document.getElementById('dynamicHeightDiv');
    var contentHeight = dynamicDiv.scrollHeight;
    dynamicDiv.style.height = contentHeight + 'px';
  }
  
  const handleChoiceOtherButton = (key, value, ques) => {
    setShow(true);
    setSelectKey(key);
    setOtherData(value);
    setOtherCounterQuestion(ques);
  };
  
  const checkOtherClick = (ind, otherOptionData) => {
    let data = selectedWidgetData[ind];
    if (data?.length) {
      let index = otherOptionData?.indexOf(data[0]);
      if (index > 2) {
        return true;
      } else {
        return false;
      }
    } else {
      return false; 
    }      
  }
  
  useEffect(() => {
    if (isLoading === false) {
      setPromptText("");   
      inputActivityHandler(false);
      if (lastPrompt?.suggestions?.length > 0) {
        setSuggestionDelay(true);
        setTimeout(() => {
          setSuggestionDelay(false);
        }, 1000);
      }
    }
  }, [isLoading])
    
  useEffect(() => {
    if (messageEl) {
    // if (messageEl?.current) {
        messageEl?.current?.addEventListener('DOMNodeInserted', event => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight});
      });
    }
  }, [])
  
  
  return (
    <div className='chat-bot-view'> 
      <div>
        <div className='mb-6 heading-parent'>
          <div className={"clean-span"+(firebaseLoader !== true ? " cursor-pointer ":" cursor-not-allowed ")} onClick={cleanChat}><img src={ Broom } alt='Broom' /></div>
        </div>
        <div id="middle-section" className='chat-bot-middle scrollable' ref={messageEl}>
            {(showText && (prompt_list?.length === 0 || prompt_list?.length > 10 * (total_page - 1))) &&
              <>
                <div className={'first-left-response ml-4 mb-3'}>
                  <Icon.CaretRightFill className='left-icon-triangle' color='#ffffff'/>
                  {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                  <p className='first-ai-heading'>SIA Says</p>
                  <p className='first-ai-response' dangerouslySetInnerHTML={{ __html: greeting_message.message }}></p>
                </div>
                <div className='first-left-suggestion ml-4 mb-3'>
                  {greeting_message?.details?.length > 0 && greeting_message?.details.map((msg,msg_index) => {
                      return (
                        <div key={"details-"+msg_index}>
                          {msg_index === 0 && <span className='or-line mb-0'>{"Maybe you can start with one of these questions."}</span>}
                          {msg_index < 3 && <p key={"greeting-suggestion-"+msg_index} onClick={()=>{if(firebaseLoader !== true){sentDirectMsg(msg.message)}}} title={msg.message} className={'greeting-suggestion-msg max-w-fit'+(firebaseLoader !== true ? " cursor-pointer ":" cursor-not-allowed ")}>{msg.message}</p>}
                        </div>
                      )
                  })}
                </div>
              </>
            }
            {showText && prompt_list?.length > 0 && prompt_list.map((msg,index)=>{
              return (
                <div key={"chatbot-msg-" + index}>
                  {msg?.prompt && <div className='right-response ml-auto mr-3 mb-3'>
                    <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                    {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                    <p className='ai-heading' onClick={()=>{setChatTransition(!chatTransition)}}>You</p>
                    <p className='ai-response'>{msg.prompt}</p>
                  </div>}
                  {msg?.answer && <div className='first-left-response ml-4 mb-3'>
                    <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                    {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                        <div className="flex mb-2 justify-between items-center">
                          <p className='not-italic font-semibold text-sm leading-[17px] text-[#59B3C6]'>SIA Says</p>
                            <a href="/Chat-Ai/tuning"
                              onClick={(e) => {
                                Cookies.set("p_id", `TRAININ${msg.id}` );
                              }}
                              className="flex h-7 rounded-xl bg-[#F8F8F8] justify-center items-center gap-2.5 p-2.5"
                            >
                            <Icon.Pencil
                              className="cursor-pointer text-gray-400 hover:text-[var(--brand-primary)] text-[16px]"
                            />
                          </a>
                        </div>
                        {/* <p className='first-ai-heading'>SIA Says</p> */}
                            
                        <p className='ai-response' dangerouslySetInnerHTML={{ __html: msg.answer }}></p>
                        {debugger_mode !== 0 && msg?.debug_url !== null && <a href={msg.debug_url} title={msg.debug_url} target='blank' className='bug-icon'><Icon.BugFill/></a>}
                        
                        {msg?.urls && msg?.urls?.crawled_urls?.list?.length > 0 && <div className='know-more-borders'>
                        <div className='learn-more-heading'>
                          <div>   
                            {learnMoreIds.includes(msg?.id) ? (
                              <div
                                className='flex justify-between items-center cursor-pointer'
                                onClick={() => {
                                handleLearnLess(msg?.id);
                              }}>
                                <span>Relevant Links</span>
                                <Icon.ChevronUp
                                  className="cb-mt-2 cb-w-[25px] cb-h-[20px] cb-mr-[0.2rem]"
                                />
                              </div>
                            ) : (
                              <div
                                className='flex justify-between items-center cursor-pointer'
                                onClick={() => {
                                handleLearnMore(msg?.id);
                              }}>
                                <span>Relevant Links</span>
                                <Icon.ChevronDown
                                  className="cb-mt-2 cb-w-[25px] cb-h-[20px] cb-mr-[0.2rem]"
                                />
                              </div>
                            )}
                          </div>
                          </div>
                          {learnMoreIds.includes(msg?.id) && <>
                            {msg?.urls && msg?.urls?.crawled_urls?.list?.length > 0 && msg?.urls?.crawled_urls?.list?.map((rank, r_index) => {
                              return (
                                <>
                                  {r_index < (moreIds.includes(msg?.id)? 5: 3) &&
                                  <span key={"r_index_"+r_index} className={'know-mores'} onClick={()=>{window.open(rank.url, "_blank");}} title={rank.title}>{ r_index+1 +". " }{rank.title}</span>}
                                </>
                              )
                            })}
                            {moreIds.includes(msg?.id) ? (
                                <div
                                  className="know-mores-expand"
                                  onClick={() => {
                                    handleLess(msg?.id);
                                  }}
                                >
                                  - See Less
                                </div>
                              ) :
                              msg?.urls?.crawled_urls?.list?.length > 3 && (
                                <div
                                  className="know-mores-expand"
                                  onClick={() => {
                                    handleMore(msg?.id);
                                  }}
                                >{`+${msg?.urls?.crawled_urls?.list?.length - 3} More`}</div>
                            )}
                          </>}
                        </div>}
                
                  </div>}
                  {(msg?.suggestions?.length > 0 && msg?.counter_question?.length === 0 && firebaseLoader !== true && suggestionDelay === false && inputActivity !== true) && <div className='first-left-suggestion ml-4 mb-3'>
                    {msg?.suggestions?.length > 0 && msg?.suggestions?.map((msg_s, msg_index) => {
                      return (
                          <div key={"details-"+msg_index}>
                            {msg_index < 3 && <p key={"greeting-suggestionsss-"+msg_index} onClick={()=>{sentDirectMsg(msg_s)}} title={msg_s} className='suggestion-msg max-w-fit'>{msg_s}</p>}
                          </div>
                        )
                    })}
                  </div>}
                  { msg?.counter_question?.length > 0 && msg?.counter_question.map((c_q,c_q_index) => {
                    return (
                      <div key={"c_q_index" + c_q_index}>
                        {(c_q.last_question_data !== true && !updateCounterStatus.includes("skipped")) && <>
                          {c_q.widget_type === "text" ? <>
                            {(c_q.counter_question !== "" && c_q_index === msg?.counter_question?.length - 1 && (chatDelayStatus === false || c_q.counter_answer !== "")) &&
                                <div className={`slide-in counter-question-left-response ml-4 mb-3 ${chatTransition ? 'active' : ''}`}>
                                <Icon.CaretRightFill className='left-counter-icon-triangle' color='#59B3C6'/>
                                {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                                <p className='counter-ai-heading'>Zoi asks</p>
                                <p className='first-ai-response' dangerouslySetInnerHTML={{ __html: c_q.counter_question }}></p>
                                {c_q.counter_answer === "" && <div className={'know-more counter-question-border'}>
                                  <form className='d-block mt-2'>
                                    {!updateCounterStatus.includes("skipped") && prompt_list.length === index + 1 ? <div className="relative flex">
                                      <input value={counterAnswerInput} className='form-meeting-input-height pr-3 w-full border-2 border-[#59B3C6] pl-2 rounded-md text-black focus:outline-none'
                                        autoFocus
                                        onChange={(e) => { setCounterAnswerInput(e.target.value) }}
                                        onKeyDown={async (e) => {
                                          if (e.key === 'Enter' && counterAnswerInput !== "") {
                                            e.preventDefault();
                                            setChatTransition(false);
                                            setTimeout(() => {
                                              sendPromptCommon("cq_input");
                                            }, 300);
                                          }
                                        }}
                                        type="name"
                                        placeholder={"Enter "+c_q?.label?.charAt(0).toUpperCase() + c_q?.label?.slice(1)}
                                      />
                                      <Icon.Send className='input-send-inside' onClick={async () => {
                                        if (counterAnswerInput !== "") {
                                          setChatTransition(false);
                                          setTimeout(() => {
                                            sendPromptCommon("cq_input");
                                          }, 300);
                                        }
                                      }} />
                                      {(!updateCounterStatus.includes("skipped") && c_q.counter_answer === "") && <span onClick={() => {
                                              setUpdateCounterStatus("Above question skipped");
                                              setInputFieldDisable(false);
                                              setChatTransition(false);
                                              if (lastPrompt?.suggestions?.length > 0) {
                                                setSuggestionDelay(true);
                                                setTimeout(() => {
                                                  setSuggestionDelay(false);
                                                }, 1000);
                                              }
                                            }}
                                          className='absolute bottom-[-17px] text-[10px] right-[2px] cursor-pointer right-icon-suggestion-bottom text-black'
                                          >Skip
                                          </span>}
                                    </div> : 
                                    <>
                                        <span className='answer-text text-black'>{prompt_list.length === index + 1 ? updateCounterStatus : (c_q.counter_answer !== "" ? "" : "Above question skipped")}</span>    
                                    </>
                                    }
                                  </form>
                                </div>}
                                </div>
                            }
                          </>
                            :
                          <>
                            <div className={`slide-in counter-question-left-response ml-4 mb-3 ${chatTransition ? 'active' : ''}`}>
                              <Icon.CaretRightFill className='left-counter-icon-triangle' color='#59B3C6'/>
                              <p className='counter-ai-heading'>Zoi asks</p>
                              <p className='first-ai-response' style={{lineHeight:"25px"}}>Answer the following question?</p>
                              {c_q.widget_questions.map((widget,w_index) => {
                                return (
                                  <>
                                    <p className='text-black mb-2 mr-4 mt-2 text-[14px] font-[600]'>{w_index+1}. {widget.counter_question}</p>
                                    <div className='flex flex-wrap'>
                                      {widget?.options_data.map((w_opt,wo_ind) => {
                                        return (
                                          <>
                                            {wo_ind < 3 &&
                                              <span
                                                className={`hover:bg-black hover:text-white mb-2 font-[600] cursor-pointer my-auto text-[12px] px-2 py-1 rounded-md mr-2 ${selectedWidgetData[w_index]?.includes(w_opt) ? "bg-black text-white":"bg-white text-black"}`}
                                                onClick={() =>
                                                  handleOptions(
                                                    w_index,
                                                    w_opt,
                                                    lastCounterData?.widget_type
                                                  )
                                                }
                                              >
                                                {w_opt.name}
                                              </span>
                                            }
                                          </>
                                        );
                                      })}
                                      <span
                                        className={`hover:bg-black hover:text-white mb-2 font-[600] cursor-pointer  my-auto  text-[12px] px-2 py-1 rounded-md mr-2 ${checkOtherClick(w_index, widget.options_data) ? "bg-black text-white":"bg-white text-black"}`}
                                        // onClick={() => { setShow(true); setOtherData(widget.options_data) }}
                                        onClick={() =>
                                          handleChoiceOtherButton(
                                            w_index,
                                            widget.options_data,
                                            widget.counter_question
                                          )
                                        }
                                      >
                                        Others
                                      </span>
                                    </div>
                                  </>
                                );
                              })}
                                <div className="relative flex my-2 pt-2 justify-end border-t-[black] border-t border-solid">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        handleWidgetSubmit()
                                      }}
                                      className="rounded bg-[#59B3C6] px-2 py-1 text-sm font-bold text-[#000] hover:text-gray-900 shadow-sm hover:bg-[#59B3C6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                      Submit
                                    </button>
                                    {(!updateCounterStatus.includes("skipped")) && <span onClick={() => {
                                        setUpdateCounterStatus("Above question skipped");
                                        setInputFieldDisable(false);
                                        setChatTransition(false);
                                        if (lastPrompt?.suggestions?.length > 0) {
                                          setSuggestionDelay(true);
                                          setTimeout(() => {
                                            setSuggestionDelay(false);
                                          }, 1000);
                                        }
                                      }}
                                    className='absolute bottom-[-16px] text-[10px] right-[8px] font-medium cursor-pointer right-icon-suggestion-bottom text-[#000]'
                                    >Skip
                                    </span>}
                                  </div>
                            </div>
                          </>}
                        </>}
                        { c_q.last_question_data !== false && <div className='first-left-response ml-4 mb-3'>
                            <Icon.CaretRightFill className='left-counter-icon-triangle' color='#ffffff'/>
                            {/* <div className='first-ai-icon'><img src={BotIcon} alt="BotIcon" /></div> */}
                            <p className='first-ai-heading'>SIA Says</p>
                            <p className='first-ai-response c_q_extracss' dangerouslySetInnerHTML={{ __html: c_q.acknowledgement || "Thanks for sharing !" }}></p>
                          </div>}
                        
                          {chatDelayStatus === true && c_q.last_question_data !== false && c_q_index === msg?.counter_question?.length-1 && <div className='first-left-response ml-4 mb-3 last-response w-[55%]' style={{width:"55%"}}>
                            <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                            {/* <div className='absolute left-[-65px] top-[0px] w-[26px]'><img src={BotIcon} alt="BotIcon" /></div> */}
                              <p className='ai-response m-0'>
                                <span>
                                  <img src={loader_gif} className='m-auto' alt="loader-gif" />
                                </span>
                              </p>
                          </div>
                          }
                        
                          {(((c_q.acknowledgement !== "" && c_q.last_question_data !== false && c_q.acknowledgement !== null) || updateCounterStatus.includes("skipped")) && suggestionDelay === false && chatDelayStatus === false && c_q_index === msg?.counter_question?.length-1 && hideGreetingSuggestion !== true ) && <div className='first-left-suggestion ml-4 mb-3'>
                            {msg?.suggestions?.length > 0 && msg?.suggestions?.map((msg_s, msg_index) => {
                              return (
                                <div key={"details-" + msg_index}>
                                    {/* {msg_index === 0 && <span className='or-line mb-0'>{"Great! Let's continue the conversation."}</span>} */}
                                    {msg_index < 3 && <p key={"greeting-suggestionsss-"+msg_index} onClick={()=>{sentDirectMsg(msg_s)}} title={msg_s} className='suggestion-msg max-w-fit'>{msg_s}</p>}
                                  </div>
                                )
                            })}
                          </div>}
                      </div>
                    )
                  })}                  
                </div>
              )
            })}
            {(showText && newPrompt && Object.keys(newPrompt).length > 0 && isLoading === true) && <>
              <div className='right-response ml-auto mr-3 mb-3'>
                <Icon.CaretRightFill className='right-icon-triangle' color='#ffffff'/>
                {/* <div className='ai-icon'><img src={Mood} alt="account_box" /></div> */}
                <p className='ai-heading'>You</p>
                <p className='ai-response'>{newPrompt.prompt}</p>
              </div>
              {message?.is_writing !== true && message?.answer === "" && isLoading === true ? <div className={"first-left-response ml-4 mb-3 last-response"} style={{width:"55%"}}> 
                <Icon.CaretRightFill className='icon-shift' color='#ffffff'/>
                <p className='ai-response'>
                <span className='loading'>
                    Generating answers
                    {/* <img src={loader_gif} className='m-auto' alt="loader-gif" /> */}
                  </span>
                </p>
              </div>
              :
              <div className={"first-left-response ml-4 mb-3"+(message?.is_writing !== true && isLoading === true && prompt_list.length === chatData.length ? " w-[55%]":" w-[85%]")}>
                <Icon.CaretRightFill className='icon-shift' color='#ffffff' />
                <p className='first-ai-heading'>SIA Says</p>
                <p className='ai-response' dangerouslySetInnerHTML={{ __html: message?.answer }}></p>
                {generatingLoader === true && <span className='animate-pulse text-[#59B3C6] block w-full text-xs font-semibold mt-[5px] pt-[5px] border-t-[#59B3C6] border-t border-solid'>Looking for References...</span>}
              </div>}
            </>
            }
          </div>
      </div>
      {showText && <div className='chat-bot-input '>
        <div className="chatbot-input">
          <textarea
            type='text'
            value={promptText}
            disabled={isLoading || inputFieldDisable}
            className='flex mr-auto ml-[0px] w-full'
            placeholder="Start Typing here..."
            onInput={handleTextareaResize}
            rows="1"
            maxLength="2000"
            ref={textareaRef}
            onKeyDown={async (e) => {
                if (e.key === 'Enter' && promptText !== "" && inputFieldDisable !== true) {
                  e.preventDefault();
                  const textarea = textareaRef.current;
                      textarea.style.height = "auto";
                  await sendPromptCommon("main_input");
                }
              }
            }
            onChange={promptAdd}
          />
          <div className='absolute right-[45px] top-[15px] w-[20px]'>
            <Icon.Send
              onClick={async () => {
                  if (promptText !== "" && inputFieldDisable !== true) {
                    const textarea = textareaRef.current;
                    textarea.style.height = "auto";
                    await sendPromptCommon("main_input");
                  }
                }
              }
            />
          </div>
          {/* <span className="width-control">
            <img
              src={calender}
              alt="calender"
              className="absolute right-[-40px] top-[2px] w-[20px]"
            />
          </span> */}
        </div>
      </div>
      }
      
      <div
        aria-live="assertive"
        className="pointer-events-none z-50 fixed inset-0 transition-opacity flex items-end px-4 py-6 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-center">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
              <div id="dynamicHeightDiv" className={"shadow-[0px_12px_100px_slategray] temporary-class relative pointer-events-auto w-[57%] max-w-sm rounded-lg bg-white ring-1 ring-black ring-opacity-5"}>
                <div className="py-3 px-6">
                  <div className="flex items-start">
                    <div className="w-0 flex-1">
                      <button
                        type="button"
                        className="flex rounded-md bg-white absolute right-1 top-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#59B3C6] focus:ring-offset-2"
                          onClick={() => {
                          setShow(false)
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                      <p className="text-sm my-2 font-semibold text-gray-900">{ otherCounterQuestion }</p>
                      <div>
                        <Multiselect
                          options={otherData?.slice(3)}
                          selectedValues={selectedWidgetData[selectKey]}
                          onRemove={(selectedList, removedItem) => {
                            handleOptions(selectKey, removedItem, lastCounterData?.widget_type);
                          }}
                          onSelect={(selectedList, selectedItem) => {
                            handleOptions(selectKey, selectedItem, lastCounterData?.widget_type);
                          }}
                          displayValue="name"
                          showArrow={true}
                        />
                      </div>
                      <p onClick={()=>{setShow(false)}} className='mt-2 w-full text-right font-bold cursor-pointer text-[#59B3C6]'>Submit</p>
                    </div>
                  </div>
                </div>
              </div>
          </Transition>
        </div>
      </div>
      
    </div>
  )
}

export default ChatbotViewer
